import { Zap } from "../../../Atoms/Icons";

// Shared hero banner for the Careers pages. Both CareersLanding and
// CareersOpenings render this same component with different text/props —
// this is the ONE place to edit if you want to change the hero look
// across both pages at once.
//
//   eyebrow      optional pill above the title, e.g. "We're Hiring"
//   title        big heading text
//   description  paragraph under the title
//   children     optional — buttons/links rendered under the description
//                (CareersLanding uses this, CareersOpenings doesn't)
//   className    optional extra classes on the <section>, for page-specific
//                spacing (e.g. CareersLanding needs a top margin the other
//                page doesn't)
export default function Hero({ eyebrow, title, description, children, className = "" }) {
  return (
    <section className={`hero-careers ${className}`}>
      <div className="containers-min mx-auto px-4 text-center">
        {eyebrow && (
          <span className="badge-pill-brand mb-4">
            <Zap size={14} /> {eyebrow}
          </span>
        )}
        <h1 className="leading-tight !h3 font-gilroylight font-light">{title}</h1>
        <p className="lead mx-auto mb-6 max-w-2xl">{description}</p>
        {children && <div className="flex justify-center gap-2 flex-wrap">{children}</div>}
      </div>
    </section>
  );
}
